// Vendor imports
const _ = require('lodash')
const qs = require('qs')
// Client lib imports
const globalPageContext = require('client/lib/business-events/page-context')
const { openWindow } = require('client/lib/window')

// Action types

const NAVIGATE = 'ROUTER_NAVIGATE'
const RELOAD = 'ROUTER_RELOAD'

// Action creators

function navigate(arg) {
  if (_.isString(arg)) {
    // Maintain compatibility with string argument form
    return navigate({ href: arg })
  }
  if (arg.currentTarget instanceof HTMLAnchorElement) {
    // Support click event on anchor tag
    arg.preventDefault()
    return navigate({
      event: arg,
      href: arg.currentTarget.getAttribute('href')
    })
  }
  const { event, href, pageContext } = arg
  const normalizedHref = normalizeHref(href)
  return function () {
    globalPageContext.persistPageContext(pageContext)
    if (event && event.metaKey) {
      openWindow(normalizedHref)
    } else {
      // https://app.asana.com/0/102902769366319/681203866231475/f
      window.location.assign(normalizedHref)
    }
  }
}

function reload() {
  return {
    type: RELOAD
  }
}

module.exports = {
  NAVIGATE,
  RELOAD,
  navigate,
  reload
}

const PROPAGATE_QUERY_HREF_REGEXP = /^\/[^/]/
const PROPAGATE_QUERY_KEYS = ['native', 'render']

function normalizeHref(href) {
  if (typeof window === 'undefined' || !PROPAGATE_QUERY_HREF_REGEXP.test(href)) {
    return href
  }
  let hrefBase = href
  let hrefQuery = {}
  const hrefQueryPos = href.indexOf('?')
  if (hrefQueryPos > -1) {
    hrefBase = href.substr(0, hrefQueryPos)
    hrefQuery = qs.parse(href.substr(hrefQueryPos + 1))
  }
  const currentQuery = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  // Propagate current "magic" query parameters to the next page
  const propagateQuery = _.pick(currentQuery, PROPAGATE_QUERY_KEYS)
  const combinedQueryString = qs.stringify({ ...propagateQuery, ...hrefQuery })
  if (combinedQueryString) {
    return `${hrefBase}?${combinedQueryString}`
  }
  return href
}
